<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-md-8">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Lançamentos Ignorados</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()" matTooltip="Voltar para lançamentos pendentes">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Lançamentos bancários que foram marcados como ignorados.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if (selection.hasValue()) {
                    <span>Ações ({{ selection.selected.length }})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="restaurarSelecionados()"
                        [disabled]="!selection.hasValue() || isRestaurando"
                        [matTooltip]="!selection.hasValue() ? 'Marque pelo menos um lançamento para restaurar' : ''"
                        matTooltipPosition="right">
                        <mat-icon class="material-symbols-outlined">restore</mat-icon>
                        <span>Restaurar selecionados</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <!-- Seletor de conta -->
        <div class="row mb-3">
            <div class="col-sm-12 col-md-12 col-lg-5">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Instituição Financeira</mat-label>
                    <mat-select [ngModel]="idContaFinanceira" (ngModelChange)="onContaChange($event)">
                        <mat-option *ngFor="let conta of _contas" [value]="conta.idContaFinanceira">
                            {{ labelConta(conta) }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="agencia">Ag. {{ agencia }} · CC {{ numeroConta }}</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <!-- Busca -->
        <div class="row search-area mb-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="busca-field">
                    <mat-label>Buscar descrição</mat-label>
                    <input matInput type="search" [(ngModel)]="pesquisa" (keyup.enter)="carregarIgnorados(true)"
                        placeholder="Busque por descrição...">
                    <button mat-icon-button matSuffix (click)="carregarIgnorados(true)" type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>

        @if (!isLoading && _dataSource.data.length > 0) {

        <!-- Tabela Desktop -->
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>

            <!-- Checkbox -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Data -->
            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef>Data</th>
                <td mat-cell *matCellDef="let row">{{ row.dataTransacao | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <!-- Descrição -->
            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef>Descrição</th>
                <td mat-cell *matCellDef="let row">{{ row.memo || '(sem descrição)' }}</td>
            </ng-container>

            <!-- FitID -->
            <ng-container matColumnDef="fitid">
                <th mat-header-cell *matHeaderCellDef>Cód.</th>
                <td mat-cell *matCellDef="let row">{{ row.fitid }}</td>
            </ng-container>

            <!-- Valor -->
            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef>Valor</th>
                <td mat-cell *matCellDef="let row">
                    <span [class.valor-entrada]="row.idNaturezaMovimentacao === naturezaEnum.Entrada"
                        [class.valor-saida]="row.idNaturezaMovimentacao === naturezaEnum.Saida">
                        {{ row.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                        {{ row.valor | abnt:'preco' }}
                    </span>
                </td>
            </ng-container>

            <!-- Ações -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações"
                        (click)="$event.stopPropagation()">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuRow="matMenu">
                        <button mat-menu-item (click)="restaurarUnico(row)">
                            <mat-icon class="material-symbols-outlined">restore</mat-icon>
                            <span>Restaurar lançamento</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Mobile View -->
        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idExtratoBancario) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary">
                        </mat-checkbox>
                        <div class="d-flex flex-column">
                            <span class="text-bold">{{ item.memo || '(sem descrição)' }}</span>
                            <small>Cód: {{ item.fitid }}</small>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item (click)="restaurarUnico(item)">Restaurar</button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <div class="row">
                        <div class="col-6 mb-2">
                            <small class="d-block">Data</small>
                            <span>{{ item.dataTransacao | date:'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="col-6 mb-2">
                            <small class="d-block">Valor</small>
                            <span [class.valor-entrada]="item.idNaturezaMovimentacao === naturezaEnum.Entrada"
                                [class.valor-saida]="item.idNaturezaMovimentacao === naturezaEnum.Saida">
                                {{ item.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                                {{ item.valor | abnt:'preco' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Ver Mais -->
        @if (_temMais) {
        <div class="col-12 text-center mt-3">
            <button mat-button [disabled]="isLoading" (click)="proximaPagina()">
                @if (isLoading) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>
        }

        } @else if (isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list title="Nenhum lançamento ignorado." subTitle="Os lançamentos que você ignorar aparecerão aqui.">
        </app-empty-list>
        }

    </div>
</div>